<template>
    <div id="cardBox2"
         class="card-box"
         :style="`max-height: calc(100vh - ${350 + newQuestionTypeHeight - 50 + (newIsBackBtn?40:0)}px);`"
    >
        <div
            class="card-item"
            :style="width === 0?`margin-right:4px;`:`width:${width};`"
            v-for="(item1, index1) in newData"
            :key="'item1'+index1"
        >
            <p class="label-tips">
                <span
                    class="tip-box"
                    v-for="(item2, index2) in item1.tips"
                    :key="'tip'+index2"
                ><span v-if="item2.name" class="tip" :class="{[item2.type]:true}">{{item2.name}}</span></span>
            </p>
            <div class="info-box">
                <!--<p class="question">-->
                    <!--{{index1 + 1}}、{{item1.question}}-->
                <!--</p>-->
                <div class="select-options">
                    <div class="options" v-html="`${item1.content}`"></div>
                    <!--<p class="option"-->
                        <!--v-for="(item3, index3) in item1.selectOptions"-->
                       <!--:key="'item3'+ index3"-->
                    <!--&gt;{{item3.name}}、{{item3.value}}</p>-->
                </div>
                <div class="answer-box">
                    <div class="row">
                        <div class="btn-answer">
                            <p
                                class="name-box yes"
                                @click="handleShow(item1)"
                            >
                                <span class="iconfont icon-daanjiexi"></span>
                                <span class="name">答案解析</span>
                                <span
                                    class="angle"
                                    :class="{active: item1.isAnalysis}"
                                ></span>
                            </p>
                            <p
                                class="name-box reback"
                                @click="handleReback(item1)"
                            >
                                <span class="iconfont">
                                    <img
                                        class="img"
                                        :src="$images.material.feedBack" alt="img" />
                                </span>
                                <span class="name">错题反馈</span>
                            </p>
                        </div>
                        <p
                            class="btn-add"
                            @click="handleAdd(item1)"
                        >
                            <span class="ico-add">+</span>添 加
                        </p>
                    </div>
                    <div v-if="item1.isAnalysis" class="analysis-box">
                        <div class="row-box">
                            <p class="answer">答案：</p>
                            <span class="txt" v-html="item1.answer"></span>
                        </div>
                        <div class="row-box">
                            <p class="analysis">解析：</p>
                            <span class="txt" v-html="item1.analysis"></span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import * as CommonServer from '../../../../../../../../api/common'
    import {Loading} from 'element-ui'
    import { mapState } from 'vuex'
    export default {
        name: "card-box",
        props: {
            width: [String, Number],
            data: Array,
            isBackBtn: [Boolean, String],
            questionTypeHeight: [Number, String]
        },
        computed: {
            ...mapState(['menusData'])
        },
        watch:{
            questionTypeHeight(vl){this.newQuestionTypeHeight = vl},
            newQuestionTypeHeight(vl){this.$emit('update:questionTypeHeight',vl)},
            data:{
                handler(vl){this.newData = vl},
                deep: true,
                immediate: true
            },
            newData:{
                handler(vl){this.$emit('update:data',vl)},
                deep: true,
                immediate: true
            },
            isBackBtn(vl){this.newIsBackBtn = vl},
            newIsBackBtn(vl){this.$emit('update:isBackBtn', vl)}
        },
        data(){
            return {
                target: null,
                newData: this.data,
                newIsBackBtn: this.isBackBtn,
                newQuestionTypeHeight: this.questionTypeHeight // 实际题型渲染高度
            }
        },
        methods: {
            loadStart(){
                this.$nextTick(()=>{
                    let div = document.getElementById('cardBox2')
                    if(div){
                        this.target = Loading.service({
                            target: div
                        });
                    }
                })
            },
            loadEnd(){
                this.target && this.$nextTick(() => { // 以服务的方式调用的 Loading 需要异步关闭
                    this.target.close();
                });
            },
            handleShow(item){
                item.isAnalysis = !item.isAnalysis
            },
            handleReback(item){
                console.log('错题反馈==>', item)
                this.$emit('onFeedBack', item)
            },
            async handleAdd(item){
                // 游戏环节判断是否支持添加
                if(this.menusData.lessonSelectedConfig?.type === 'game'){
                    this.$message.warning(this.$enums.warnType.game)
                    return false
                }
                // PPT环节判断是否支持添加
                if(this.menusData.lessonSelectedConfig?.type === 'html'){
                    this.$message.warning(this.$enums.warnType.ppt)
                    return false
                }
                console.log('添加==>', item)
                // 1.通知服务端使用次数加一
                // 2.通知cocos当前添加一个题库
                await CommonServer.default.updateQuestion({id: item.id})
                this.$toCocosMessage({type: 'AddResource', value: {type: 'questionBank', ...item}})

            }
        }
    }
</script>

<style lang="scss" scoped>
.card-box{
    display: flex;
    flex-direction: column;
    margin-left: 20px;
    margin-right: 10px;
    max-height: calc(100vh - 350px);
    margin-bottom: 12px;
    overflow-y: auto;

    .card-item{
        background: #E4E7ED;
        border-radius: 4px 4px 0px 0px;
        margin-bottom: 14px;
        &:last-child{
            margin-bottom: 0px;
        }

        .label-tips {
            display: flex;
            flex-direction: row;
            align-items: center;

            .tip-box {
                margin: 8px 0px;

                .tip {
                    padding: 2px 4px;
                    background-color: gainsboro;
                    border-radius: 2px;
                    font-size: 12px;
                    font-weight: 400;
                    color: #FFFFFF;
                    margin-left: 10px;

                    &.blue {
                        background-color: #2888EE;
                    }

                    &.green {
                        background-color: #46AC79;
                    }

                    &.violet {
                        background-color: #7746AC;
                    }

                    &.browngreen {
                        background-color: #2E9CA6;
                    }
                }
            }
        }

        .info-box{
            background-color: white;
            padding: 16px;
            margin: 2px;
            border-radius: 2px 2px 0px 0px;
            overflow: auto;

            .select-options{
                font-size: 14px;
                font-weight: 500;
                color: #303133;
                line-height: 22px;
                margin-bottom: 11px;

                & /deep/ p:nth-child(1){
                    /*margin-top: 11px;*/
                }
                & /deep/ p{
                    font-size: 14px;
                    font-weight: 400;
                    color: #606266;
                    line-height: 26px;
                }
            }

            .answer-box{
                .row{
                    display: flex;
                    flex-direction: row;
                    justify-content: space-between;
                    align-items: center;

                    .btn-answer{
                        display: flex;
                        flex-direction: row;
                        justify-content: flex-start;
                        align-items: center;

                        .name-box{
                            display: flex;
                            flex-direction: row;
                            justify-content: flex-start;
                            align-items: center;
                            margin-right: 30px;
                            cursor: pointer;

                            &.reback .img{
                                width: 15px;
                                height: 16px;
                                position: relative;
                                top: 1px;
                                object-fit: contain;
                            }

                            .icon-daanjiexi{
                                color: #46AC79;
                            }

                            .icon-cuotifankui{
                                color: #F54531;
                            }

                            &.yes {
                                .angle {
                                    content: '';
                                    width: 0;
                                    height: 0;
                                    border-width: 0 4px 5px;
                                    border-style: solid;
                                    border-color: transparent transparent #303133;
                                    transition: all .2s linear;

                                    &.active {
                                        transform: rotate(180deg);
                                    }
                                }
                            }

                            .name{
                                font-size: 14px;
                                font-weight: 400;
                                color: #303133;
                                line-height: 20px;
                                margin-left: 8px;
                                margin-right: 8px;
                            }
                        }
                    }
                    .btn-add{
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        width: 69px;
                        height: 26px;
                        background: #303133;
                        border-radius: 4px;
                        font-size: 14px;
                        font-weight: 400;
                        color: #FFFFFF;
                        line-height: 26px;
                        cursor: pointer;
                        transition: background-color .2s linear;

                        &:active{
                            background-color: #BCBFC6;
                        }

                        .ico-add{
                            margin-right: 4px;
                            font-size: 16px;
                            position: relative;
                            top: -2px;
                        }
                    }
                }
                .analysis-box{
                    margin-top: 17px;
                    background: #F5F7FA;
                    padding: 12px;
                    border-radius: 2px;

                    .row-box{
                        display: flex;
                        flex-direction: row;
                        justify-content: flex-start;

                        .answer,analysis{
                            flex-shrink: 0;
                        }
                    }

                    .answer{
                        font-size: 14px;
                        font-weight: 400;
                        color: #303133;
                        line-height: 20px;
                    }
                    .analysis{
                        font-size: 14px;
                        font-weight: 400;
                        color: #303133;
                        line-height: 20px;

                        .txt{
                            font-size: 14px;
                            font-weight: 400;
                            color: #606266;
                            line-height: 20px;
                        }
                    }
                }
            }
        }
    }
}
</style>
